import { Placement } from '@popperjs/core';
import { useState } from 'react';
import { Popper } from '../Popper';
import clsx from 'clsx';

interface TooltipProps {
  children: React.ReactNode;
  className?: string;
  placement?: Placement;
  showArrow?: boolean;
  title: string;
  show?: boolean;
}

export const Tooltip = (props: TooltipProps) => {
  const {
    children,
    className,
    placement = 'bottom',
    showArrow = true,
    show = true,
    title,
  } = props;
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  if (!show) return <>{children}</>;

  return (
    <>
      <div
        className={clsx(className, 'h-fit z-10')}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onMouseUp={() => setIsVisible(false)}
        ref={setReferenceElement}
      >
        {children}
      </div>
      <Popper
        anchorEl={referenceElement}
        isVisible={isVisible && Boolean(title.trim().length)}
        offsetY={10}
        placement={placement}
        showArrow={showArrow}
      >
        <span className="px-2 py-1 text-[0.65rem] text-white whitespace-nowrap">
          {title}
        </span>
      </Popper>
    </>
  );
};
